<template>
  <div class="sidebar-wrapper" data-simplebar="true">
    <div class="sidebar-header">
      <div class="">
        <img src="/static/images/OSK-logo.png" class="logo-icon-2" alt="" />
      </div>
      <a style="cursor: pointer" href="javascript:;" class="toggle-btn ml-auto">
        <i class="bx bx-menu"></i>
      </a>
    </div>
    <ul class="metismenu mm-show" id="menu">
      <li v-for="(data, index) in menus" :key="index">
        <a
          style="cursor: pointer"
          :class="data.sub_menus ? 'has-arrow' : ''"
          aria-expanded="false"
          v-on:click="redirect('menu-' + index, data.url,  data.access)"
        >
          <div class="parent-icon icon-color-1">
            <i
              v-if="
                data.access.code == 'dashboard' ||
                data.access.code == 'manage_home'
              "
              class="bx bx-home-alt"
            ></i>
            <i v-else-if="data.access.code == 'settings'" class="bx bx-cog"></i>
            <i
              v-else-if="data.access.code == 'transactions'"
              class="bx bx-dollar-circle"
            ></i>
            <i
              v-else-if="
                data.access.code == 'news_announcements' ||
                data.access.code == 'news_announcements_view'
              "
              class="bx bx-volume-full"
            ></i>
            <i
              v-else-if="data.access.code == 'support'"
              class="bx bx-support"
            ></i>
            <i v-else class="bx bx-spreadsheet"></i>
          </div>
          <div class="menu-title">{{ data.name }}</div>
        </a>

        <ul :id="'menu-' + index" class="mm-collapse" v-show="data.sub_menus">
          <li v-for="(sub_menu, sub_index) in data.sub_menus" :key="sub_index">
            <a
              style="cursor: pointer"
              :class="sub_menu.sub_menus ? 'has-arrow' : ''"
              v-on:click="
                redirect('sub-menu-' + index + sub_index, sub_menu.url,sub_menu.access)
              "
            >
              <div class="parent-icon icon-color-1">
                <i style="font-size: 13px" class="bx bx-right-arrow-alt"></i>
              </div>
              <div class="menu-title">{{ sub_menu.name }}</div>
            </a>

            <ul
              :id="'sub-menu-' + index + sub_index"
              class="mm-collapse"
              v-show="sub_menu.sub_menus"
            >
              <li
                v-for="(sub_sub_menu, sub_sub_index) in sub_menu.sub_menus"
                :key="sub_sub_index"
              >
                <a
                  style="cursor: pointer"
                  :id="'sub-sub-menu-' + index + sub_index + sub_sub_index"
                  :class="sub_sub_menu.sub_menus ? 'has-arrow' : ''"
                  v-on:click="
                    redirect(
                      'sub-sub-menu-' + index + sub_index + sub_sub_index,
                      sub_sub_menu.url, sub_sub_menu.access
                    )
                  "
                >
                  <div class="parent-icon icon-color-1">
                    <i
                      style="font-size: 13px"
                      class="bx bx-right-arrow-alt"
                    ></i>
                  </div>
                  <div class="menu-title">{{ sub_sub_menu.name }}</div>
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>
<script>
import router from "../router";

export default {
  name: "Menu",
  data() {
    return {
      isAdmin: process.env.IS_ADMIN,
      menus: [],
      accessM:null,
      menuList: [],
    };
  },
  mounted() {
    this.getMenu();
  },
  methods: {
    route(pageName) {
      router.push(pageName);

    },
    redirect(id, url, acces) {
      localStorage.setItem("objasc",JSON.stringify(acces) )
      localStorage.setItem( "accd", acces.code);
      this.$shareService.removeAllPageData();
      var elems = document.querySelector(".mm-active");
      if (elems !== null) {
        elems.classList.remove("mm-active");
      }
      var element = document.getElementById(id);
      if (element) {
        element.parentElement.classList.add("mm-active");
      }

      console.log("ID", id)
      console.log("URL", url)
      // console.log("ACCESS", acces)
      console.log("element", element)

      if (url == "#") {
        if (id) {
          if (element) {
            if (element.className.indexOf("mm-show") == -1) {
              element.classList.add("mm-show");
            } else {
              element.classList.remove("mm-show");
            }
          }
        }
      } else {
        url = url.replace("#", "");
        if (window.location.pathname != url) {
          router.push(url);
        }
      }
    },
    async getMenu() {
      await this.$api
        .getAPI({
          _action: "left-menus",
        })
        .then((res) => {
          if (res && res.list) {
            this.menus = res.list;

            for (var i = 0; i < this.menus.length; i++) {
              if (this.menus[i].access) {
                this.menuList.push(this.getMenuDetail(this.menus[i]));
              }

              if (this.menus[i].sub_menus) {
                for (var j = 0; j < this.menus[i].sub_menus.length; j++) {
                  if (this.menus[i].sub_menus[j].access) {
                    this.menuList.push(
                      this.getMenuDetail(this.menus[i].sub_menus[j])
                    );
                  }

                  if (this.menus[i].sub_menus[j].sub_menus) {
                    for (
                      var k = 0;
                      k < this.menus[i].sub_menus[j].sub_menus.length;
                      k++
                    ) {
                      if (this.menus[i].sub_menus[j].sub_menus[k].access) {
                        this.menuList.push(
                          this.getMenuDetail(
                            this.menus[i].sub_menus[j].sub_menus[k]
                          )
                        );
                      }
                    }
                  }
                }
              }
            }
            if (window.location.pathname == "/access-denied") {
              this.$router.go(-1);
            }
          }
        })
        .catch((e) => {});
    },
    getMenuDetail(menu) {
      this.accessM = menu
      return {
        title: menu.name,
        forAcode: menu.access.code,
        url: menu.url,
        can_read: menu.access.can_read,
        can_delete: menu.access.can_delete,
        can_create: menu.access.can_create,
        can_update: menu.access.can_update,
        can_print: menu.access.can_print,
      };
    },
    getMenuAccess(url) {
      if (this.menuList.length ) {
        if (!url) {
          url = window.location.pathname;
        }

        // Special case for state and city
        if(url == '/state' || url == '/city') {
          url = '/country'
        }

        for (var i = 0; i < this.menuList.length; i++) {
          if (this.menuList[i].url == url) {
            return this.menuList[i];
          }
        }
      } else {
        // router.push("/access-denied");

        return {
          can_read: 1,
          can_delete: 1,
          can_create: 1,
          can_update: 1,
          can_print: 1,
        };
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Menu.vue